var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionFileUpload = function SvgQuestionFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.22 5a.6.6 0 0 1 .43.18l3.96 3.96a.6.6 0 0 1 .18.43v10.06c0 .67-.55 1.22-1.22 1.22H7.82c-.67 0-1.22-.55-1.22-1.22V6.22C6.6 5.55 7.15 5 7.82 5zm-.3 1.16v3.1c0 .34.27.62.6.62h3.11l-3.72-3.72z"
  })));
};
export default SvgQuestionFileUpload;